// @flow
import React from 'react';
import MarkdownRender from 'components/common/MarkdownRender';
import './PartnerContent.scss';

type Props = {
  body: string,
  theme: string,
  thumbnail: ?string,
  onSetToc: (toc: any) => void,
  onActivateHeading: (headingId: string) => void,
};

const PartnerContent = ({ body, onSetToc, onActivateHeading, thumbnail, theme }: Props) => (
  <div className="PartnerContent">
    <div className="partner-info">
      {thumbnail && (
        <div className="partner-thumbnail">
          <img src={thumbnail} alt="partner-thumbnail" />
        </div>
      )}
    </div>
    <div className="contents">
      <MarkdownRender
        body={body}
        onSetToc={onSetToc}
        onActivateHeading={onActivateHeading}
        theme={theme || 'github'}
      />
    </div>
  </div>
);

PartnerContent.Placeholder = () => (
  <div className="PartnerContent placeholder">
    <div className="partner-thumbnail">
      <div className="fake-img" />
    </div>
    <div className="contents">
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '75%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
    </div>
  </div>
);

export default PartnerContent;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerContent/PartnerContent.js